import HydraulicSimulatorRepository from "./HydraulicSimulatorRespository";

export default class HydraulicSimulatorService {
  private readonly hydraulicSimulatorRepository: HydraulicSimulatorRepository =
    new HydraulicSimulatorRepository();

  async postInpAssets(file: string, name: string, others: any): Promise<any> {
    const response = await this.hydraulicSimulatorRepository.postInpAssets(
      file,
      name,
      others
    );
    return response;
  }

  async getAttributesFromAsset(mmsId: string, assetId: string, type: string, locationId: number) {
    const response =
      await this.hydraulicSimulatorRepository.getAttributesFromAsset(
        mmsId,
        assetId,
        type,
        locationId
      );
    return response;
  }

  async getAssetsFromMmsid(mmsId: string, locationId: number) {
    return await this.hydraulicSimulatorRepository.getAssetsFromMmsid(mmsId, locationId);
  }

  async postSaveChangesModelFile(mmsId: string, data: any, locationId: number) {
    const response =
      await this.hydraulicSimulatorRepository.postSaveChangesModelFile(
        mmsId,
        data,
        locationId
      );
    return response;
  }
}
